import { useState, useEffect } from 'react'
import styles from './CoursesSection.module.scss'
import SectionTitle from '../SectionTitle/SectionTitle'
import ModalCourse from '../ModalCourse/ModalCourse'

export default function CoursesSection() {
	const [courses, setCourses] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)
	const [selectedCourse, setSelectedCourse] = useState(null)
	const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';
	useEffect(() => {
		fetch(`${API_PREFIX}/api/sections/get/courses/list`)
			.then((res) => {
				if (!res.ok) throw new Error('Ошибка загрузки данных о курсах')
				return res.json()
			})
			.then((data) => {
				setCourses(data.courses ?? [])
				setLoading(false)
			})
			.catch((e) => {
				setError(e.message)
				setLoading(false)
			})
	}, [])

	return (
		<section id='courses' className={styles.coursesSection}>
			<SectionTitle>Наши направления</SectionTitle>

			{loading && <div>Загрузка...</div>}
			{error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}

			{!loading && !error && (
				<div className={styles.coursesSectionWrapper}>
					{courses.map((course) => (
						<div className={styles.courseCard} key={course.id}>
							<div className={styles.courseCardBadge}>
								для детей {course.age}
							</div>
							<div className={styles.courseCardMain}>
								<div className={styles.courseCardContent}>
									<h3 className={styles.courseCardTitle}>{course.title}</h3>
									<ul className={styles.courseCardList}>
										{course.description?.map((text, i) => (
											<li key={i}>{text}</li>
										))}
									</ul>
								</div>
								<div className={styles.courseCardImage}>
									<img src={course.image} alt={course.title} />
								</div>
							</div>
							<button
								className={styles.courseCardButton}
								onClick={() => setSelectedCourse(course)}
							>
								Подробнее
							</button>
						</div>
					))}
				</div>
			)}

			{selectedCourse && (
				<ModalCourse
					course={selectedCourse}
					onClose={() => setSelectedCourse(null)}
				/>
			)}
		</section>
	)
}
